<template>
  <div>
    <popup2 v-model="showPopup" width="428">
      <component
        :entity="entity"
        :is="action"
        :type="typeEdit"
        :items="dropdownRights"
        :title="`Edit ${fieldName}`"
        @close="showPopup = false"
        @input="() => {}"
      />

      <layout v-if="typeAction === 'detail-notification'">
        <template slot="header">Delivery info</template>

        <div class="pa-5">
          <div
            class="subtitle-1 mb-3"
            v-for="type in currentContext.types"
            :key="type.id"
          >
            Delivery path: {{ type.deliveryPath }} <br />
            Date: {{ convertDate(type.createdAt) }} <br />
            Message: {{ type.message }} <br />
            Delivered: {{ type.delivered }} <br />
            <template v-if="type.error">Error: {{ type.error }}</template>
          </div>
        </div>
        <template slot="footer">
          <v-spacer />
          <v-btn color="primary" text @click="copyDeliveryInfo(currentContext)">
            Copy
          </v-btn>
          <v-btn text @click.stop="handleClose">
            Close
          </v-btn>
        </template>
      </layout>
    </popup2>

    <app-entity
      :current-show="currentShow"
      :is-nested-entity="isNestedEntity"
      :entity="entity"
      :loading="loading"
      :nested-entity="nestedEntity"
      :tab-data="logsList"
      @close-card="closeCard"
      @action="handleAction"
      @show-nested-entity="showNestedEntity"
      @close-history="currentShow = 'entity'"
      @close-nested-card="closeNestedCard"
      @show-full-logs="showFullLogs"
    />
  </div>
</template>

<script>
import useNotification from '@/api/notifications/useNotification';
import { onMounted, watch } from '@vue/composition-api';
import Layout from '@/layouts/LayoutPopup';
import { Wormhole } from 'portal-vue';

import convertDate from '@/utils/convertDate';
import copyToClipboard from '@/utils/copyToClipboard';
export default {
  name: 'NotificationItem',
  components: {
    Layout,
    Edit: () => import('../edit')
  },
  props: ['id', 'isNestedEntity'],
  setup(props, context) {
    const entityComposition = useNotification(props, context);

    const closeNestedCard = () => {
      Wormhole.close({
        to: 'nested',
        from: 'object'
      });

      Wormhole.close({
        to: 'user-portal',
        from: 'user'
      });
    };

    const closeCard = () => {
      closeNestedCard();
      entityComposition.entity.value = null;
      context.root.$router.push({
        name: context.root.$route.meta.rootRouteName,
        query: context.root.$route.query
      });
    };

    const copyDeliveryInfo = type => {
      let value = `
       Delivery path: ${type.deliveryPath}
       Date: ${convertDate(type.createdAt)}
       Message: ${type.message}
       Delivered: ${type.delivered}
      `;
      copyToClipboard(value);
    };

    watch(
      () => props.id,
      () => {
        entityComposition.loadData(props.id);
      }
    );

    onMounted(() => {
      entityComposition.loadData(props.id);
    });

    return {
      ...entityComposition,
      closeNestedCard,
      closeCard,
      copyToClipboard,
      convertDate,
      copyDeliveryInfo
    };
  }
};
</script>
